import { useState } from "react"

export default function Calculator(){
    const [calcValue, setCalcValue] = useState("")

    return(
        <section className="flex flex-col py-[20px] h-[70vh] items-center justify-center bg-[#f7f7f7] w-[100%] expoSpace">
            <div className="bg-[#10ba46] h-[100%] w-[250px] rounded-[15px] flex flex-col items-start justify-start p-[15px]">
            <input 
                className="w-[100%] bg-[#021709] py-[20px] rounded-[15px] text-[white] px-[20px] text-right
                text-[25px]
                "
                name="display"
                value={calcValue}
            />

            <div className="flex flex-row h-[100%] overflow-y-hidden  items-center justify-between w-[100%] pt-[20px]">
                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    value="AC"
                    type="button"
                    onClick={() => {
                        setCalcValue("")
                    }}
                />
                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="DE"
                    
                    onClick={() => {
                        setCalcValue(calcValue?.slice(0 , -1))
                    }}
                />
                                <input 
                    className="bg-[white] rounded-[50%]  p-[15px] w-[23%]"
                    type="button"
                    value="."
                    
                    onClick={() => {
                        setCalcValue(calcValue + ".")
                    }}
                />
                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="/"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "/")
                    }}
                />
            </div>

            <div className="flex flex-row h-[100%] overflow-y-hidden  items-center justify-between w-[100%] pt-[20px]">
                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    value="7"
                    type="button"
                    onClick={() => {
                        setCalcValue(calcValue + "7")
                    }}
                />
                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="8"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "8")
                    }}
                />
                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="9"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "9")
                    }}
                />
                                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="*"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "*")
                    }}
                />
            </div>

            <div className="flex flex-row h-[100%] overflow-y-hidden  items-center justify-between w-[100%] pt-[20px]">
                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    value="4"
                    type="button"
                    onClick={() => {
                        setCalcValue(calcValue + "4")
                    }}
                />
                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="5"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "5")
                    }}
                />
                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="6"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "6")
                    }}
                />
                                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="-"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "-")
                    }}
                />

            </div>



            <div className="flex flex-row  h-[100%] overflow-y-hidden items-center justify-between w-[100%] pt-[20px]">
                <input 
                    className="bg-[white] rounded-[50%]  p-[15px] w-[23%]"
                    value="1"
                    type="button"
                    onClick={() => {
                        setCalcValue(calcValue + "1")
                    }}
                />
                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="2"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "2")
                    }}
                />
                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="3"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "3")
                    }}
                />
                                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="+"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "+")
                    }}
                />
            </div>

            <div className="flex flex-row h-[100%] overflow-y-hidden   items-end justify-end w-[100%] pt-[20px]">
                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%]"
                    value="00"
                    type="button"
                    onClick={() => {
                        setCalcValue(calcValue + "00")
                    }}
                />
                                <input 
                    className="bg-[white] rounded-[50%] p-[15px]  w-[23%] ml-[5px]"
                    type="button"
                    value="0"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "0")
                    }}
                />
                                                <input 
                    className="bg-[white] hidden rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="0"
                    
                    onClick={() => {
                        setCalcValue(calcValue + "0")
                    }}
                />
                                                                <input 
                    className="bg-[white] ml-[5px] rounded-[50%] p-[15px]  w-[23%]"
                    type="button"
                    value="="
                    
                    onClick={() => {
                        setCalcValue(eval(calcValue))
                    }}
                />
                                {/* <button 
                    className="bg-[white] text-[30px] text-center ml-[5px] flex flex-col items-center justify-center rounded-[50%]   w-[23%]"
                    onClick={() => {
                        setCalcValue(eval(calcValue))
                        
                    }}
                >
                    =
                </button> */}
            </div>

            </div>
        </section>
    )
}